import { useEffect, useMemo } from "react";

import { useConfiguration } from "@is/hooks";
import { getConfigurationStyles, loadFont } from "@is/utils";

const useManageThemeWrapper = () => {
  const { appearance } = useConfiguration();

  useEffect(() => {
    if (appearance) {
      if (appearance.baseFontUrl) {
        loadFont({
          name: "BaseFont",
          src: appearance.baseFontUrl,
        });
      }

      if (appearance.baseFontStrongUrl) {
        loadFont({
          name: "BaseFontStrong",
          src: appearance.baseFontStrongUrl,
        });
      }

      if (appearance.displayFontUrl) {
        loadFont({
          name: "DisplayFont",
          src: appearance.displayFontUrl,
        });
      }
    }
  }, [appearance]);

  import("@is/themes/base.module.css");

  const styles = useMemo(
    () => getConfigurationStyles(appearance),
    [appearance]
  );

  return {
    styles,
  };
};

export default useManageThemeWrapper;
